<template>
  <div>
    <router-link to="/">
      <el-image
        :src="require(`@/assets/logo-primary.png`)"
        class="height-100-px text-left"
      ></el-image>
    </router-link>
    <h2 class="color-primary text-weight-600">
      {{ title }}
    </h2>
    <div v-if="showSigninWith" class="flex-display js-center">
      <div
        @click="signinWithFaceBook()"
        class="box-signin-socail mg-x-4 cursor-pointer"
        style="background-color: #0065b3"
      >
        <i class="fab fa-facebook-f color-white"></i>
      </div>

      <div
        @click="signinWithGoogle()"
        class="box-signin-socail mg-x-4 cursor-pointer"
        style="background-color: #ffffff"
      >
        <el-image
          :src="require('@/assets/google.png')"
          class="text-left vc-middle"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/service/axios.js";
import jwt_decode from "jwt-decode";

export default {
  props: {
    title: {
      type: String,
      default() {
        return "";
      },
    },
    showSigninWith: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  mounted() {
    google.accounts.id.initialize({
      client_id:
        "131212105511-9qpbqji63m4ebuejq63ufafch8cpjldn.apps.googleusercontent.com",
      callback: (r) => this.googleLoginCallback(r),
    });
  },
  methods: {
    async googleLoginCallback(response) {
      const responsePayload = jwt_decode(response.credential);

      let email = responsePayload.email;
      let password = `${responsePayload.email}t@t.wiThGoogle`;

      let haveEmail = await this.haveEmail(email);

      if (haveEmail) {
        this.$emit("signIn", email, password);
      } else {
        let obj = {
          nameTh: responsePayload.given_name,
          lastNameTh: responsePayload.family_name,
          image: responsePayload.picture,
          email: email,
          password: password,
        };

        this.signup(obj, "google");
      }
    },

    signinWithGoogle() {
      const createFakeGoogleWrapper = () => {
        const googleLoginWrapper = document.createElement("div");
        // Or you can simple hide it in CSS rule for custom-google-button
        googleLoginWrapper.style.display = "none";
        googleLoginWrapper.classList.add("custom-google-button");

        // Add the wrapper to body
        document.body.appendChild(googleLoginWrapper);

        // Use GSI javascript api to render the button inside our wrapper
        // You can ignore the properties because this button will not appear
        google.accounts.id.renderButton(googleLoginWrapper, {
          theme: "outline",
          size: "large",
        });

        const googleLoginWrapperButton = googleLoginWrapper.querySelector(
          "div[role=button]"
        );

        return {
          click: () => {
            googleLoginWrapperButton.click();
          },
        };
      };

      // Now we have a wrapper to click
      const googleButtonWrapper = createFakeGoogleWrapper();

      googleButtonWrapper.click();
    },
    async signinWithFaceBook() {
      FB.login(
        (responseLogin) => {
          if (responseLogin.authResponse) {
            FB.api(
              "/me",
              "GET",
              {
                fields:
                  "id,first_name,last_name,email,picture.width(480).height(480)",
              },
              async (response) => {
                let haveEmail = await this.haveEmail(response.email);
                let password = `${response.id}t@t.wiThFaceBook`;
                if (haveEmail) {
                  this.$emit("signIn", response.email, password);
                } else {
                  let obj = {
                    nameTh: response.first_name,
                    lastNameTh: response.last_name,
                    email: response.email,
                    image: response.id,
                    password: password,
                  };

                  this.signup(obj, "faceBook");
                }
              }
            );
          }
        },
        { scope: "email" }
      );
    },
    async haveEmail(email) {
      let have = false;
      let obj = {
        email: email,
      };

      await HTTP.post(`email`, obj).then((res) => {
        if (res.data.success) {
          have = false;
        } else {
          have = true;
        }
      });

      return have;
    },
    signup(obj, from) {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      formData.append("profileFrom", obj.image);
      formData.append("titleName", "");
      formData.append("nameTH", obj.nameTh);
      formData.append("surnameTH", obj.lastNameTh);
      formData.append("nameEN", "");
      formData.append("surnameEN", "");
      formData.append("countryCode", "");
      formData.append("mobilephone", "");
      formData.append("identification", "");
      formData.append("birthday", "");
      formData.append("position", "");
      formData.append("address", "");
      formData.append("postcode", "");
      formData.append("subdistrict", "");
      formData.append("district", "");
      formData.append("province", "");

      let institution = {
        name: "",
        type: "",
        etc: "",
        address: "",
        postcode: "",
        subdistrict: "",
        district: "",
        province: "",
      };

      formData.append("institution", JSON.stringify(institution));
      formData.append("email", obj.email);
      formData.append("password", obj.password);
      formData.append("from", from);

      HTTP.post(`sign/up`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.$emit("signIn", obj.email, obj.password);
          } else {
            this.$alert("เข้าสู่ระบบไม่สำเร็จกรุณาลองใหม่อีกครั้ง", {
              closeOnClickModal: true,
              confirmButtonText: "OK",
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$alert("เข้าสู่ระบบไม่สำเร็จกรุณาลองใหม่อีกครั้ง", {
            closeOnClickModal: true,
            confirmButtonText: "OK",
            type: "error",
          });
          console.log("signup error", e);
        });
    },
  },
};
</script>
